import { TimelineSkeleton } from "@/ui2/molecules/Timeline";

export function AcuityHistoryTimelineSkeleton() {
  return <TimelineSkeleton />;
}
